import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CheckIcon } from 'lucide-react';
export function ValueStack() {
  const bonuses = [{
    title: 'Entrenamiento Mental y Rendimiento en el Fútbol Juvenil',
    value: '€29',
    image: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Checklist de Resiliencia para Después del Partido',
    value: '€15',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía de Alimentación Inteligente Antes y Después de Competir',
    value: '€24',
    image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Recetario Deportivo para Futbolistas',
    value: '€19',
    image: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Manual del Padre que Acompaña al Futbolista con Inteligencia',
    value: '€35',
    image: 'https://images.unsplash.com/photo-1536104968055-4d61aa56f46a?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Diario de Progreso y Entrenamiento del Futbolista',
    value: '€20',
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía del Vestuario: Mentalidad, Convivencia y Actitud',
    value: '€25',
    image: 'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Historias de Superación en el Fútbol Argentino',
    value: '€19',
    image: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    title: 'Guía principal: Cómo Despertar el Amor por el Fútbol en tu Hijo',
    value: '€49',
    image: 'https://images.unsplash.com/photo-1596464716127-f2a82984de30?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  const totalValue = 235; // Sum of all values
  return <section className="py-16 md:py-24 bg-white" data-id="element-262">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-12" data-id="element-264">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-amber/10 mb-6" data-id="element-265">
            <GiftIcon className="w-8 h-8 text-brand-amber" data-id="element-266" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4" data-id="element-267">
            Además vas a recibir estos{' '}
            <span className="text-brand-amber" data-id="element-268">bonos exclusivos:</span>
          </h2>
          <p className="text-lg text-brand-slate-light" data-id="element-269">
            Complementos diseñados para potenciar los resultados de la guía
            principal.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-270">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-row items-center p-4 md:p-6 bg-brand-cream rounded-xl border border-brand-slate/5 hover:border-brand-amber/30 transition-colors group gap-3 sm:gap-0" data-id="element-271">
              <div className="flex-shrink-0 w-12 h-16 sm:w-14 sm:h-18 md:w-16 md:h-20 rounded-lg overflow-hidden shadow-sm sm:mr-4 md:mr-6 group-hover:scale-105 transition-transform" data-id="element-272">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-273" />
              </div>
              <div className="flex-grow min-w-0" data-id="element-274">
                <h4 className="text-sm sm:text-lg font-bold text-brand-slate group-hover:text-brand-green transition-colors leading-tight" data-id="element-275">
                  {bonus.title}
                </h4>
                <p className="text-xs sm:text-sm text-brand-slate-light mt-1 flex items-center" data-id="element-276">
                  <CheckIcon className="w-3 h-3 sm:w-4 sm:h-4 text-brand-green mr-1 flex-shrink-0" data-id="element-277" />
                  Incluido gratis hoy
                </p>
              </div>
              <div className="flex-shrink-0 text-right ml-2 sm:ml-4" data-id="element-278">
                <span className="text-xs sm:text-sm text-brand-slate-light uppercase tracking-wider font-semibold block" data-id="element-279">
                  Valor
                </span>
                <span className="text-lg sm:text-xl font-bold text-brand-slate line-through opacity-50" data-id="element-280">
                  {bonus.value}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-slate text-white rounded-2xl p-8 md:p-10 text-center shadow-2xl relative overflow-hidden" data-id="element-281">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-amber" data-id="element-282"></div>

          <h3 className="text-2xl font-heading mb-6" data-id="element-283">
            Resumen de tu Inversión
          </h3>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-8" data-id="element-284">
            <div data-id="element-285">
              <p className="text-white/60 text-sm uppercase tracking-wider mb-1" data-id="element-286">
                Valor Total Real
              </p>
              <p className="text-4xl font-bold text-white/50 line-through" data-id="element-287">
                €{totalValue}
              </p>
            </div>
            <div className="hidden md:block w-px h-16 bg-white/20" data-id="element-288"></div>
            <div data-id="element-289">
              <p className="text-brand-amber font-bold text-sm uppercase tracking-wider mb-1" data-id="element-290">
                Precio Especial Hoy
              </p>
              <p className="text-5xl md:text-6xl font-heading text-brand-amber" data-id="element-291">
                €17.99
              </p>
            </div>
          </div>

          <p className="text-white/80 text-lg" data-id="element-292">
            Te llevás todo el paquete con un{' '}
            <strong className="text-white" data-id="element-293">85% de descuento</strong>.
          </p>
          <p className="text-white/50 text-sm mt-3" data-id="element-294">
            Valor en ARS calculado en la siguiente pantalla.
          </p>
        </motion.div>
      </div>
    </section>;
}